class OrderController extends AbstractController
	@register()
	@inject '$stateParams',
		'$q'
		'translate'
		'OrderRepository'
		'RenderRepository'
		'statusEnum': 'BACKEND_ORDER_STATUS'
		'BACKEND_ORDER_ENTITY_TYPE'
		'SEARCH_CONFIGURATION'
		'parseBool'

	initialize: ->
		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.order,
			sortProperty: 'timestamp'
			itemsCount: 0
		})

		@orders = []
		@statusOptions = [
			{
				name: @translate('wbo.orders.status.canceled')
				value: @statusEnum.CANCELED
				label_class: 'label-warning'
			}
			{
				name: @translate('wbo.orders.status.open')
				value: @statusEnum.OPEN
				label_class: 'label-primary'
			}
			{
				name: @translate('wbo.orders.status.completed')
				value: @statusEnum.COMPLETED
				label_class: 'label-success'
			}
		]

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.with 'order_line_items',
			'order_line_items>addon_line_items',
			'order_line_items>bundled_line_items',
			'transactions',
			'register'

		@OrderRepository
			.findByQuery query
			.then (response) =>
				@orders = @initializeOrders(response.data)
				@filterDTO.itemsCount = @orders.length

				@searching = false

	getQuery: ->
		query = @OrderRepository.createQuery()

		filterGroup = @filterDTO.searchConfiguration[0].filters

		if !_.isEmpty(@$stateParams.start_date) && !_.isEmpty(@$stateParams.end_date)
			filterGroup.timestamp.value =
				start: @$stateParams.start_date
				end: @$stateParams.end_date

		if !_.isEmpty(@$stateParams.order_id)
			filterGroup.id.value = @$stateParams.order_id

		if !_.isEmpty(@$stateParams.customer_id)
			filterGroup.customer_id.value = @$stateParams.customer_id

		if !_.isEmpty(@$stateParams.tender_type_id)
			query.criteria 'transactions>tender_type_id', '=', @$stateParams.tender_type_id

		if !_.isEmpty(@$stateParams.transaction_type)
			query.criteria 'transactions>type', '=', @$stateParams.transaction_type

		if !_.isEmpty(@$stateParams.shop_id)
			query.criteria 'shop_id', 'LIKE', "%#{@$stateParams.shop_id}%"

		return query

	initializeOrders: (data) ->
		orders = @OrderRepository.calculateOrderSum data

		for order in orders
			order.currency ?= order.transactions?[0]?.base_currency
			order.label_class = _.find(@statusOptions, {value: order.status}).label_class
			order.is_preorder = @parseBool(order.is_preorder)
			order.is_paid = @parseBool(order.is_paid)

			if order.is_preorder
				order.type_label = 'general.order.type.preorders'

			if order.entity_type != @BACKEND_ORDER_ENTITY_TYPE.ORDER
				order.type_label = 'general.order.type.' + order.entity_type.toLowerCase()

		return orders

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'status'
			statuses = []

			for status in @statusOptions
				if status.value?
					statuses.push({id: status.value, name: status.name})

			return @$q.when(statuses)
